import type { TFunction } from "i18next";
import type { PasswordStrength } from "../Types/AccountTypes";

const PASSWORD_REGEX = /^(?=.*[!@#$%^&*])(?=.*[0-9])(?=.*[A-Z]).{8,}$/;

export const GetPasswordStrength = (
  newPassword: string,
  t: TFunction
): PasswordStrength => {
  if (
    newPassword.length > 8 &&
    /\d/.test(newPassword) &&
    /[A-Z]/.test(newPassword)
  ) {
    return {
      percent: 100,
      status: "success",
      text: t("accountSettings.passwordStrength.strong"),
    };
  }
  if (newPassword.length > 5) {
    return {
      percent: 60,
      status: "active",
      text: t("accountSettings.passwordStrength.medium"),
    };
  }
  if (newPassword.length > 0) {
    return {
      percent: 30,
      status: "exception",
      text: t("accountSettings.passwordStrength.weak"),
    };
  }
  return { percent: 0, status: "normal", text: "" };
};

export const IsPasswordValid = (newPassword: string): boolean =>
  PASSWORD_REGEX.test(newPassword);

export const IsNameValid = (name: string): boolean =>
  Boolean(name && name.length >= 2);
